var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"create-merchant"},[_c('div',{staticClass:"coming-soon"},[_c('img',{attrs:{"src":require("@/assets/img/smiling.svg"),"alt":"Coming Soon"}}),_c('h3',[_vm._v("Coming Soon")])])])
}]

export { render, staticRenderFns }